import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { CrudService } from '../../../crud/crud.service';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';

import { saveAs } from 'file-saver';
import * as moment from 'moment';
import * as JSZip from 'jszip';
import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable';
import * as jQuery from 'jquery';

@Component({
  selector: 'app-resumen-resagado',
  templateUrl: './lista.component.html'
})

export class FacturaComponent{
  tamano = document.body.clientHeight;
  datos = [];
  cargando = false;

  error_busqueda = false;
  sin_resultado = '';
  rangos_fecha;
  carpeta;
  modulo;
  controlador;
  controller;
  modulo_actual;
  actual;
  icono;

  logos64;
  permisos = JSON.parse(localStorage.getItem("permisos"));

  activarReporte = false;

  date = new Date();
  MinDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);

  fecha_desde = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
  fecha_actual = new Date(this.date.getFullYear(), this.date.getMonth() + 1, this.date.getDate());

  desde = this.date.getFullYear() + '-' + (this.date.getMonth() + 1) + '-' + '1';
  hasta = this.date.getFullYear() + '-' + (this.date.getMonth() + 1) + '-' + this.date.getDate();
  rango = '';
  tipo = 0;
  texto = '';
  formas_pagos;
  tipos_formas_pagos;

  folio_desde = '';
  folio_hasta = '';
  fecha_venta = false;
  formas_pagos_id = '';

  niveles_educativos = [];

  configuracion = JSON.parse(localStorage.getItem('configuracion'));

  constructor(
    private crudService: CrudService,
    private route: ActivatedRoute,
    private title: Title,
    private fb: FormBuilder,
    private _sanitizer: DomSanitizer) { }

  ngOnInit() {

    this.rangos_fecha = [
      { 'id': '', 'nombre': 'Fecha desde - hasta' },
      { 'id': moment().format('YYYY-MM-DD') + '/' + moment().format('YYYY-MM-DD'), 'nombre': 'Hoy' },
      { 'id': moment().subtract(1, 'days').format('YYYY-MM-DD') + '/' + moment().subtract(1, 'days').format('YYYY-MM-DD'), 'nombre': 'Ayer' },
      { 'id': moment().subtract(7, 'days').format('YYYY-MM-DD') + '/' + moment().format('YYYY-MM-DD'), 'nombre': 'Últimos 7 días' },
      { 'id': moment().startOf('month').format('YYYY-MM-DD') + '/' + moment().endOf('month').format('YYYY-MM-DD'), 'nombre': 'Este mes' },
      { 'id': moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') + '/' + moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), 'nombre': 'Mes pasado' },
      { 'id': moment().startOf('year').format('YYYY-MM-DD') + '/' + moment().endOf('year').format('YYYY-MM-DD'), 'nombre': 'Este año' },
      { 'id': moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD') + '/' + moment().subtract(1, 'years').endOf('year').format('YYYY-MM-DD'), 'nombre': 'Año pasado' },
      { 'id': moment('1969-01-01', 'YYYY-MM-DD', true).format('YYYY-MM-DD') + '/' + moment().format('YYYY-MM-DD'), 'nombre': 'Todos los tiempos' }
    ];
    this.obtenerCatalogos('tipo-forma-pago', 'tipos_formas_pagos');

    this.obtenerCatalogos('logos64', 'logos64', 'logo64')
  }

  buscar() {
    this.cargando = true;
    this.datos = [];
    let json: any = {
      rango: this.rango,
      desde: this.desde,
      hasta: this.hasta,
      tipo: this.tipo,
      texto: this.texto,
      formas_pagos_id: this.formas_pagos_id,
      folio_desde: this.folio_desde,
      folio_hasta: this.folio_hasta,
      fecha_venta: this.fecha_venta
    };
    this.crudService.crear(json, 'reporte/resumen/factura').subscribe(
      resultado => {
        this.cargando = false;
        // se encontro resultado
        if (resultado.status === 200) {
          for (const key in resultado) {
            if (resultado.hasOwnProperty(key)) {
              const element = resultado[key];
              this[key] = element;
            }
          }

        } else {
          this.sin_resultado = resultado.messages;
          setTimeout(() => {
            this.sin_resultado = '';
          }, 3500);
        }
        this.error_busqueda = false;
      },
      error => {
        this.cargando = false;
        this.error_busqueda = true;
        setTimeout(() => {
          this.error_busqueda = false;
        }, 3500);
      }
    );
  }
  parametros = {
    pagina: 0,
    limite: 0
  };
  obtenerCatalogos(url, model, id = '') {
    this.crudService.lista(this.parametros, url).subscribe(
      resultado => {
        this[model] = resultado.data;
        if(id != ''){
          document.getElementById(id).click();
        }
      },
      error => {
      }
    );
  }
  zip_xml(datos) {
    const jszip = new JSZip();
    datos.forEach(element => {
      jszip.file(element.folio + '.xml', element.xml);
    });

    jszip.generateAsync({ type: 'blob' }).then(function (content) {
      saveAs(content, 'facturacion_xml.zip');
    });
  }

  imprimir() {
    let titulo = 'Reporte Resumen Facturacion';
    let doc = new jsPDF("landscape", "mm", "letter");

    let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
    if (logo != '' && logo != undefined && logo != null)
      doc.addImage(logo, "PNG", 10, 5, 25, 20, "left", "FAST");

    let linea = 22;
    //Header
    doc.setFontSize(15);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.nombre,108, 12,  {align:"center"});

    doc.setFontSize(14);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.subnombre,108, 18,  {align:"center"});
    linea += 4;
    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.sucursal.direccion.split(",")[0], 140, linea, {align:"center"});
    linea += 4;
    doc.text(this.configuracion.sucursal.direccion.split(",")[1],140, linea,  {align:"center"});
    linea += 4;
    doc.text("RFC: " + this.configuracion.sucursal.facturacion.rfc,140, linea,  {align:"center"});
    linea += 6;

    doc.setFont("helvetica", "", "bold");
    doc.setFontSize(6);
    doc.text('------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------',140, linea,  {align:'center'});
    linea += 6;

    doc.setFontSize(12);
    doc.text( titulo,140, linea, {align:'center'});
    linea += 6;

    let elem = document.getElementById("tabla");
    let data = (doc as any).autoTableHtmlToJson(elem);

    (doc as any).autoTable(data.columns, data.rows, {
      didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: linea,
      styles: {
        fontSize: 6, font: "helvetica",
        halign: "center",
        fillColor: "#FFFFFF",
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.3
      },
      columnStyles: {
        0: {cellWidth: 50}, 
        1: {cellWidth: 20}, 
        2: {cellWidth: 19}, 
        3: {cellWidth: 10},
        4: {cellWidth: 30}, 
        5: {cellWidth: 30}, 
        6: {cellWidth: 30},
        7: {cellWidth: 30}, 
        8: {cellWidth: 25},
        9: {cellWidth: 15}
       },
      headStyles: {
        lineColor: "#000000",
        lineWidth: 0.3
      },
      tableWidth: 'auto',
      margin: { right: 10, left: 10 },
    });
    
    linea +=  9 * this.datos.length + 5;
    
    elem = document.getElementById("tabla2");
    data = (doc as any).autoTableHtmlToJson(elem);

    (doc as any).autoTable(data.columns, data.rows, {
      didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: linea,
      styles: {
        fontSize: 6, font: "helvetica",
        halign: "center",
        fillColor: "#FFFFFF",
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.3
      },
      headStyles: {
        lineColor: "#000000",
        lineWidth: 0.3
      },
      tableWidth: 'auto',
      margin: { right: 10, left: 10 },
    });

    linea += 20;
    if(this.niveles_educativos.length > 0){
      elem = document.getElementById("tabla3");
      data = (doc as any).autoTableHtmlToJson(elem);

      (doc as any).autoTable(data.columns, data.rows, {
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: linea,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        tableWidth: 'auto',
        margin: { right: 10, left: 10 },
      });

      linea += 8 * this.niveles_educativos.length ;
    }
    elem = document.getElementById("tabla4");
    data = (doc as any).autoTableHtmlToJson(elem);

    (doc as any).autoTable(data.columns, data.rows, {
      didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: linea,
      styles: {
        fontSize: 6, font: "helvetica",
        halign: "center",
        fillColor: "#FFFFFF",
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.3
      },
      headStyles: {
        lineColor: "#000000",
        lineWidth: 0.3
      },
    });
    
    window.open((doc as any).output('bloburl'), '_blank');
  }

  excel() {
    let colspan = document.getElementsByTagName('table')[0].children[0].children[0].childElementCount;
    let titulo = 'Reporte Facturas';
    let excelData = "<table><tr><th colspan='" + colspan + "'><h1>" + titulo + " <h1></th></tr></table>";
    let html = document.getElementById('imprimir').innerHTML;
    html = html.replace(/\$/g, '');
    excelData += html;
    let blob = new Blob([excelData], { type: "text/comma-separated-values;charset=utf-8" });
    saveAs(blob, titulo + ".xls");
  }

  logo_sucursal;
  logo_empresa;

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
    }
  }
}
